/* Rquiere de mixin.js */

var trackManifestoTrackShipping = {
	data () {
		return {
			listTrackManifestoTrackShippings: [],
			methodsTrackManifestoTrackShipping: {
				get: 'trackManifestoTrackShippings',
			},
			paginationTrackManifestoTrackShipping: [],
			searchTrackManifestoTrackShipping: '',
            searchingTrackManifestoTrackShipping: false,
		}
	},
	methods:{
		getAllTrackManifestoTrackShipping(page = 1) {
			this.searchingTrackManifestoTrackShipping = true
			let parameters = '?search=' + this.searchTrackManifestoTrackShipping + '&page=' + page
			this.axiosActionIS(this.getApiBackend + this.methodsTrackManifestoTrackShipping.get + parameters, 'GET', 'getAllTrackManifestoTrackShippingResult')
        },
		getAllTrackManifestoTrackShippingResult(response) {
			this.searchingTrackManifestoTrackShipping = false
            if(response.data.success) {
                this.listTrackManifestoTrackShippings = response.data.data
                this.paginationTrackManifestoTrackShipping = response.data.paginate    
            }
            this.getAllTrackManifestoTrackShippingResultLocal(response)
		},
        getAllTrackManifestoTrackShippingResultLocal(response) {
            console.log('getAllTrackManifestoTrackShippingResultLocal no desarrollado', response)
        },
	},
};

export default trackManifestoTrackShipping;